import * as React from 'react'

export default function LabelLoader() {
  return (
    <div className="mt-3 w-full">
      <div className="flex h-16 w-full animate-pulse rounded-lg border border-gray-200">
        <div className="w-28 bg-spindle"></div>
      </div>
    </div>
  )
}
